import { red } from "@mui/material/colors";
import { jsx as _jsx } from "react/jsx-runtime";
export function LogiCtrlError(props) { return /*#__PURE__*/ _jsx("div", { style: { marginTop: 4, padding: "4px 8px", backgroundColor: red["50"], color: red["700"], borderRadius: 4, fontSize: 12, lineHeight: 1.4 }, children: props.error }); }
